module.exports = __webpack_public_path__ + "img/blueDashboard.3d06b497.svg";